import React, { useEffect, useRef, useState } from 'react'
import '../survey.css'
import {} from 'recharts'

import { buttonName, withDrawnCumtomer } from '@/pages/board/boardItem'
import { useAppSelector } from '@/redux/hooks'
import {
  AgeResultData,
  CommentData,
  CommentGroupData,
  GenderResultData,
  OptionList,
  SurveyGroupData,
  SurveyResultItem,
} from '../surveyItem'
import commonUtils from '@/utils/commonUtils'
import { useAxios } from '@/context/axiosContext'
import { useNavigate } from 'react-router-dom'
import { useDialog } from '@/context/dialogContext'
import { ApexBarChart, ApexDonutChart, Badge } from '@/components'
import { useResponsive } from '@/hooks/useResponsive'
import { justifyContent } from 'styled-system'

interface ListItemProps {
  surveyList: SurveyGroupData[]
  activeSurveySn?: number
  onRefresh: () => void // 부모가 내려준 새로고침용 함수
}

type ModalAction = 'submit' | 'insert' | 'delete' | 'update'
type TabType = 'result' | 'gender' | 'age'

export const SurveyListItem: React.FC<ListItemProps> = ({
  surveyList,
  activeSurveySn,
  onRefresh,
}) => {
  const axios = useAxios()
  const { showAlert, showConfirm } = useDialog()
  const [activeIndex, setActiveIndex] = useState<number | null>(0)
  const { isAuthenticated, user } = useAppSelector((state) => state.auth)
  const [commentList, setCommentList] = useState<CommentGroupData>({})
  const [surveySn, setSurveySn] = useState<number>()
  const [formData, setFormData] = useState<{ [optionSn: number]: string }>({})
  const [surveyResult, setSurveyResult] = useState<SurveyResultItem[]>([])
  const [genderResult, setGenderResult] = useState<any[]>([])
  const [ageGroups, setAgeGroups] = useState<string[]>([])

  // 또는 더 구체적인 타입으로
  const [ageResult, setAgeResult] = useState<{
    options: any
    series: any[]
  }>({
    options: {},
    series: [],
  })
  const [showResults, setShowResults] = useState(false)
  const [optionList, setOptionList] = useState<string[]>([])
  const [activeTab, setActiveTab] = useState<TabType>('result')
  const [animateProgress, setAnimateProgress] = useState(false)

  const [rawSurveyResult, setRawSurveyResult] = useState<SurveyResultItem[]>([])
  const [rawGenderResult, setRawGenderResult] = useState<GenderResultData[]>([])
  const [rawAgeResult, setRawAgeResult] = useState<AgeResultData[]>([])
  const [currentChartData, setCurrentChartData] = useState<any>(null)
  const { isMobile, isTablet, isDesktop } = useResponsive()
  const colors = ['#f77eb9', '#fdbd88', '#7ebcff', '#7ee5e5']
  const [openedComments, setOpenedComments] = useState<{
    [key: number]: boolean
  }>({})

  const toggleComment = (optionSn: number) => {
    setOpenedComments((prev) => ({
      ...prev,
      [optionSn]: !prev[optionSn],
    }))
  }
  const tabs: { key: TabType; label: string }[] = [
    { key: 'result', label: '전체' },
    { key: 'gender', label: '성별' },
    { key: 'age', label: '연령대' },
  ]

  //const currentData = defaultData[activeTab]

  // 기존 useEffect (탭 변경 시) - 그대로 유지
  useEffect(() => {
    // 탭 변경 시 프로그레스 바 애니메이션 재실행
    setAnimateProgress(false)
    const timer = setTimeout(() => {
      setAnimateProgress(true)
    }, 100)

    return () => clearTimeout(timer)
  }, [activeTab])

  // 추가: 모달이 열렸을 때 애니메이션 트리거를 위한 useEffect
  useEffect(() => {
    if (showResults && currentChartData?.length > 0) {
      // 모달이 열리고 데이터가 있을 때 애니메이션 시작
      setAnimateProgress(false)
      const timer = setTimeout(() => {
        setAnimateProgress(true)
      }, 200) // 모달 오픈 애니메이션 이후에 실행

      return () => clearTimeout(timer)
    }
  }, [showResults, currentChartData])

  // 최초 진입용 (1회)
  useEffect(() => {
    if (activeSurveySn) {
      setSurveySn(activeSurveySn)
      setActiveIndex(
        surveyList.findIndex((item) => item.surveySn === activeSurveySn),
      )
      getCommentList(activeSurveySn)
    }
  }, [activeSurveySn, surveyList])

  // 이후 유저 클릭 시
  useEffect(() => {
    if (activeIndex !== null) {
      const sn = surveyList[activeIndex]?.surveySn
      if (sn && sn !== surveySn) {
        setSurveySn(sn)
        getCommentList(sn)
      }
    }
  }, [activeIndex])

  const resultsRef = useRef<HTMLDivElement>(null)

  const handleClick = (index: number) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index))
  }

  // 초기 로드 시 활성 설문 찾아서 열어두기
  useEffect(() => {
    const activeIndex = surveyList.findIndex(
      (item) => item.surveyActive === 'Y',
    )
    if (activeIndex !== -1) {
      setActiveIndex(activeIndex)
    }
  }, [surveyList])

  // 댓글 섹션 열림/닫힘 상태 관리 (surveyIndex-optionIndex 형태로 저장)
  const [openComments, setOpenComments] = useState('')

  // 초기 로드 시 활성 설문 찾아서 열어두기
  useEffect(() => {
    const activeIndex = surveyList.findIndex(
      (item) => item.surveyActive === 'Y',
    )
    if (activeIndex !== -1) {
      setActiveIndex(activeIndex)
    }
  }, [surveyList])

  // 설문 섹션 토글 함수

  // 댓글 섹션 토글 함수
  const handleCommentToggle = (surveyIndex: number, optionIndex: number) => {
    const commentKey = `${surveyIndex}-${optionIndex}`
    setOpenComments((prev) =>
      prev.includes(commentKey)
        ? prev.replace(commentKey + ',', '').replace(commentKey, '')
        : prev + commentKey + ',',
    )
  }
  // ApexCharts 전용 변환 함수들
  const convertToApexResultChart = (surveyResult: SurveyResultItem[]) => {
    // x축 categories는 A, B, C로 설정 (라벨은 숨김)
    const categories = surveyResult.map((item) => item.optionTitle)

    // 범례용 라벨 (A. optionTitle 형태)
    const legendLabels = surveyResult.map(
      (item, index) => `${item.optionTitle}`,
    )

    const data = surveyResult.map((item) => item.resultCount ?? 0)

    // 최대값을 기준으로 Y축 범위 계산
    const maxValue = Math.max(...data)
    const yAxisMax = Math.max(10, Math.ceil(maxValue * 1.5))

    return {
      options: {
        chart: {
          type: 'bar',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '35%',
            endingShape: 'rounded',
            distributed: true, // 각 bar마다 다른 색상 적용
          },
        },
        xaxis: {
          categories: legendLabels, // A, B, C, ...
          labels: {
            show: true, // x축 라벨 숨기기
          },
          axisBorder: {
            show: false, // x축 테두리도 숨김 (선택사항)
          },
          axisTicks: {
            show: false, // x축 눈금도 숨김 (선택사항)
          },
        },
        yaxis: {
          min: 0,
          max: yAxisMax,
          tickAmount: 10,
          forceNiceScale: true,
        },
        dataLabels: {
          enabled: true,
          formatter: function (val: number, opts: any) {
            return `${val}표`
          },
        },
        colors: colors,
        legend: {
          show: false,
          position: 'bottom',
          customLegendItems: legendLabels, // 커스텀 범례 라벨 사용
          markers: {
            fillColors: colors, // 범례 마커 색상을 차트 색상과 동일하게
          },
        },
      },
      series: [
        {
          name: '득표',
          data: data,
        },
      ],
    }
  }

  const convertToApexGenderChart = (
    genderResult: GenderResultData[],
    optionList: string[],
  ) => {
    // x축 categories는 A, B, C로 설정 (라벨은 숨김)
    const categories = optionList.map(
      (title, index) => String.fromCharCode(65 + index), // A, B, C, ...
    )

    // 범례용 라벨 (A. optionTitle 형태)
    const legendLabels = optionList.map((title, index) => `${title}`)

    const maleData = optionList.map((title) => {
      const male = genderResult.find(
        (el) => el.optionTitle === title && el.gender === 'M',
      )
      return male?.resultCount || 0
    })

    const femaleData = optionList.map((title) => {
      const female = genderResult.find(
        (el) => el.optionTitle === title && el.gender === 'F',
      )
      return female?.resultCount || 0
    })

    const maxValue = Math.max(...maleData, ...femaleData)
    const yAxisMax = Math.max(10, Math.ceil(maxValue * 1.5))

    return {
      options: {
        chart: {
          type: 'bar',
          toolbar: { show: false },
        },
        xaxis: {
          categories: legendLabels, // A, B, C, ...
          labels: {
            show: true, // x축 라벨 숨기기
          },
          axisBorder: {
            show: false, // x축 테두리도 숨김
          },
          axisTicks: {
            show: false, // x축 눈금도 숨김
          },
        },
        yaxis: {
          min: 0,
          max: yAxisMax,
          tickAmount: 10,
          forceNiceScale: true,
        },
        dataLabels: {
          enabled: true,
          formatter: function (val: number, opts: any) {
            return `${val}표`
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '35%',
            distributed: false, // 그룹 바를 위해 false로 변경
          },
        },
        legend: {
          show: false,
          position: 'bottom',
          customLegendItems: legendLabels, // 옵션 타이틀을 범례로 사용
          markers: {
            fillColors: colors.slice(0, legendLabels.length), // 옵션 개수만큼 색상 할당
          },
        },
        colors: ['#3B82F6', '#EF4444'], // 남자(파랑), 여자(빨강) 색상
      },
      series: [
        {
          name: '남자',
          data: maleData,
        },
        {
          name: '여자',
          data: femaleData,
        },
      ],
    }
  }

  const convertToApexAgeChart = (
    ageResult: AgeResultData[],
    optionList: string[],
  ) => {
    const ageGroupsSet = new Set<string>()
    const resultMap: Record<string, any> = {}

    ageResult.forEach((item) => {
      const { optionTitle, ageGroup, ageCount } = item
      ageGroupsSet.add(ageGroup)

      if (!resultMap[optionTitle]) {
        resultMap[optionTitle] = {}
      }

      resultMap[optionTitle][ageGroup] = ageCount || 0
    })

    const ageGroups = Array.from(ageGroupsSet).sort()

    optionList.forEach((optionTitle) => {
      if (!resultMap[optionTitle]) {
        resultMap[optionTitle] = {}
      }

      ageGroups.forEach((group) => {
        if (!(group in resultMap[optionTitle])) {
          resultMap[optionTitle][group] = 0
        }
      })
    })

    const categories = surveyResult.map((item) => item.optionTitle)

    // 연령대별 시리즈 데이터
    const series = ageGroups.map((ageGroup) => ({
      name: ageGroup,
      data: optionList.map(
        (optionTitle) => resultMap[optionTitle][ageGroup] || 0,
      ),
    }))

    // Y축 최대값 계산
    const allValues = series.flatMap((serie) => serie.data)
    const maxValue = Math.max(...allValues, 0)
    const yAxisMax = Math.max(10, Math.ceil(maxValue * 1.5))
    const legendLabels = surveyResult.map(
      (item, index) => `${item.optionTitle}`,
    )

    // 연령대별 색상 매핑
    const ageColorMap: Record<string, string> = {
      '20대': '#3B82F6',
      '30대': '#EF4444',
      '40대': '#10B981',
      '50대': '#F59E0B',
      '60대': '#8B5CF6',
      '70대': '#EC4899',
      '80대': '#84CC16',
    }

    const graphColors = ageGroups.map(
      (group) => ageColorMap[group] || '#888888',
    )

    return {
      options: {
        chart: {
          type: 'bar',
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '35%',
            endingShape: 'rounded',
            distributed: false, // 각 bar마다 다른 색상 적용
          },
        },
        xaxis: {
          categories: categories, // A, B, C, ...
          labels: {
            show: true, // x축 라벨 숨기기
          },
          axisBorder: {
            show: false, // x축 테두리도 숨김 (선택사항)
          },
          axisTicks: {
            show: false, // x축 눈금도 숨김 (선택사항)
          },
        },
        yaxis: {
          min: 0,
          max: yAxisMax,
          tickAmount: 10,
          forceNiceScale: true,
        },
        dataLabels: {
          enabled: true,
          formatter: function (val: number) {
            return val > 0 ? `${val}표` : ''
          },
        },
        colors: graphColors, // 그래프용 색상
        legend: {
          show: false,
          position: 'bottom',
          customLegendItems: legendLabels,
          markers: {
            fillColors: colors, // 범례용 색상 (그래프와 다름)
          },
        },
      },
      series: series,
      ageGroups: ageGroups,
    }
  }

  const handleTabClick = (tab: TabType) => {
    setActiveTab(tab)

    let chartData

    switch (tab) {
      case 'result':
        chartData = convertToApexResultChart(rawSurveyResult)
        break
      case 'gender':
        chartData = convertToApexGenderChart(rawGenderResult, optionList)
        break
      case 'age':
        chartData = convertToApexAgeChart(rawAgeResult, optionList)
        break
      default:
        chartData = convertToApexResultChart(rawSurveyResult)
    }

    setCurrentChartData(chartData)
  }

  const handleChange = (optionSn: number, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [optionSn]: value,
    }))
  }

  const getRemainingTime = (endDate: string) => {
    const now = new Date()
    const end = new Date(endDate)
    const diffMs = end.getTime() - now.getTime()

    if (diffMs <= 0) return '투표 종료'

    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
    const diffHours = Math.floor(
      (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    )

    if (diffDays === 0) {
      return `${diffHours}시간 남음`
    }

    return `${diffDays}일 ${diffHours}시간 남음`
  }

  const formatDate = (dateString: string, isDetail = false) => {
    if (!dateString) return ''

    const date = new Date(dateString)
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const seconds = date.getSeconds().toString().padStart(2, '0')

    const now = new Date()
    const isToday =
      year === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      day === now.getDate().toString().padStart(2, '0')

    // 상세(detail) 페이지일 경우 항상 yyyy.MM.dd hh:mm:ss 형식
    if (isDetail) {
      return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`
    }

    // 오늘 날짜인 경우에도 yyyy.MM.dd 형식으로 출력
    return `${year}.${month}.${day}`
  }

  const handleModalAction = (
    type: ModalAction,
    optionSn: number,
    surveySn: number,
    userVoted: boolean,
  ) => {
    if (type === 'submit') {
      if (userVoted) {
        showConfirm({
          title: (
            <>
              기존 투표 내역은 무효 처리돼요.
              <br />
              계속 진행할까요?
            </>
          ),
          confirmBtnName: buttonName.confirm,
          cancelBtnName: buttonName.cancel,
          onConfirm() {
            submitSurvey(optionSn, surveySn)
          },
        })
        return
      } else {
        submitSurvey(optionSn, surveySn)
      }
    }
  }

  const submitSurvey = async (optionSn: number, surveySn: number) => {
    if (!isAuthenticated || !user) {
      showAlert({
        type: 'error',
        title: '투표를 하려면 로그인이 필요해요.',
      })
      return
    }

    if (!optionSn || !surveySn) {
      showAlert({
        type: 'error',
        title: '투표 옵션을 선택해주세요.',
      })
      return
    }

    const selected = {
      regId: user?.cstId,
      surveySn: surveySn,
      optionSn: optionSn,
      cstId: user?.cstId,
    }

    try {
      await axios.post('/survey/submitSurvey', selected)
      showAlert({
        type: 'success',
        title: '투표가 완료되었어요!',
        onClose: () => {
          onRefresh()
        },
      })
    } catch (err: any) {
      showAlert({
        type: 'warning',
        title: '다시 시도해주세요!',
      })
    }
  }

  const getCommentList = async (surveySn?: number) => {
    const response = await axios.get(`/survey/getCommentList`, {
      headers: { 'Cache-Control': 'no-cache' },
      params: {
        cmpnyCd: '001',
        surveySn: surveySn,
      },
    })

    const { commentList }: { commentList: CommentData[] } = response.data.data

    const groupComments = commentList.reduce(
      (acc: CommentGroupData, comment) => {
        const key = comment.optionSn
        if (!acc[key]) {
          acc[key] = []
        }
        acc[key].push(comment)
        return acc
      },
      {},
    )
    setCommentList(groupComments)
  }

  const showSurveyResult = (
    surveySn: number,
    voters?: number,
    surveyActive?: string,
  ) => {
    if (voters === 0 && surveyActive === 'Y') {
      showAlert({
        type: 'error',
        title: (
          <>
            아직 투표한 인원이 없어요.
            <br />첫 투표를 해보세요!
          </>
        ),
      })
      return
    }

    if (voters === 0 && surveyActive === 'N') {
      showAlert({
        type: 'error',
        title: (
          <>
            투표가 마감되었어요.
            <br />
            투표한 인원이 없어 결과를 확인할 수 없어요.
          </>
        ),
      })
      return
    }

    if (!isAuthenticated && !user) {
      showAlert({
        type: 'error',
        title: '로그인 후 확인이 가능해요.',
      })
    }
    //setShowResults((prev) => !prev)
    //getSurveyResult(surveySn)

    // 모달 열 때 상태 초기화
    resetModalState()
    setShowResults(true)
    getSurveyResult(surveySn)
  }

  // 모달 상태 초기화 함수 추가
  const resetModalState = () => {
    // 탭을 기본값으로 리셋
    setActiveTab('result')

    // 차트 데이터 초기화
    setCurrentChartData(null)

    // 결과 데이터들 초기화
    setSurveyResult([])
    setGenderResult([])
    setAgeResult({
      options: {},
      series: [],
    })
    setAgeGroups([])
    setOptionList([])

    // 원본 데이터들 초기화
    setRawSurveyResult([])
    setRawGenderResult([])
    setRawAgeResult([])

    // 애니메이션 상태 초기화 - false로 먼저 설정
    setAnimateProgress(false)
  }

  // 모달 닫기 함수 추가
  const closeModal = () => {
    setShowResults(false)
    // 모달이 완전히 닫힌 후 상태 초기화 (애니메이션 고려)
    setTimeout(() => {
      resetModalState()
    }, 300) // CSS 트랜지션 시간에 맞춰 조정
  }

  const getSurveyResult = async (surveySn: number) => {
    const response = await axios.get(`/survey/getSurveyResult`, {
      headers: { 'Cache-Control': 'no-cache' },
      params: {
        cmpnyCd: '001',
        surveySn: surveySn,
      },
    })

    const { surveyResult, genderTopResult, ageTopResult, optionList } =
      response.data.data

    if (
      [surveyResult, genderTopResult, ageTopResult, optionList].every(
        Array.isArray,
      )
    ) {
      const option = optionList.map((opt: OptionList) => opt.optionTitle)

      // 원본 데이터 저장
      setRawSurveyResult(surveyResult)
      setRawGenderResult(genderTopResult)
      setRawAgeResult(ageTopResult)
      setOptionList(option)

      // 기존 형태로도 저장 (다른 곳에서 사용한다면)
      setSurveyResult(surveyResult) // 원본 그대로
      //setGenderResult(convertGenderChartData(genderTopResult, option)) // 기존 변환 함수 사용

      // const { chartData, ageGroups } = convertToApexAgeChart(
      //   ageTopResult,
      //   option,
      // )
      // setAgeResult(chartData) // 기존 변환 함수 사용
      // setAgeGroups(ageGroups)

      const ageChartResult = convertToApexAgeChart(ageTopResult, option)
      setAgeResult({
        options: ageChartResult.options,
        series: ageChartResult.series,
      })
      setAgeGroups(ageChartResult.ageGroups)

      // 초기 차트 데이터 설정 (ApexCharts 형식으로 변경)
      setCurrentChartData(convertToApexResultChart(surveyResult))

      // 데이터 로드 완료 후 애니메이션 트리거
      setTimeout(() => {
        setAnimateProgress(true)
      }, 100)
    }
  }

  const insertComment = async (optionSn: number, surveySn: number) => {
    const rawCommentCn = formData[optionSn]
    const commentCn = rawCommentCn?.trim()

    if (!commentCn) {
      showAlert({
        type: 'warning',
        title: '댓글을 입력해 주세요.',
      })
      return
    }

    const comment = {
      cstId: user?.cstId,
      surveySn,
      optionSn,
      commentCn,
    }

    try {
      const response = await axios.post('/survey/insertComment', comment)
      setFormData((prev) => ({ ...prev, [optionSn]: '' }))

      if (response.data.common.resultMsg) {
        showAlert({
          type: 'error',
          title: response.data.common.resultMsg,
        })
        return
      }

      showAlert({
        type: 'success',
        title: '댓글이 등록되었어요!',
        onClose: () => getCommentList(surveySn),
      })
    } catch (err: any) {
      console.error('insertComment failed:', err)
      showAlert({
        type: 'error',
        title: '댓글 등록 중 오류가 발생했어요. 잠시 후 다시 시도해 주세요.',
      })
    }
  }

  const deleteComment = async (commentSn: number, surveySn?: number) => {
    if (!commentSn) return

    const comment = {
      cstId: user?.cstId,
      commentSn: commentSn,
      surveySn: surveySn,
    }

    try {
      await axios.post('/survey/deleteComment', comment)
      showAlert({
        type: 'success',
        title: '댓글이 삭제되었어요!',
        onClose: () => getCommentList(surveySn),
      })
    } catch (err: any) {
      console.error('Error insertComment:', err)
    }
  }

  const getSurveyStatusLabel = (surveyActive: string): string => {
    const mapping: { [key: string]: string } = {
      Y: '진행중',
      N: '종료',
    }

    return mapping[surveyActive] || '[투표 종료]' // 기본값으로 [투표 종료] 반환
  }

  const generateResultData = (surveyResult: SurveyResultItem[]) => {
    if (!surveyResult || surveyResult.length === 0) return []

    const totalVotes = surveyResult.reduce(
      (sum, item) => sum + (item.resultCount || 0),
      0,
    )

    const classNames = ['option01', 'option02', 'option03', 'option04']

    // 프론트에서 퍼센트 계산
    const percentData = surveyResult.map((item) => {
      const count = item.resultCount || 0
      const rawPercent = totalVotes > 0 ? (count / totalVotes) * 100 : 0
      return {
        ...item,
        voteCount: count,
        percent: rawPercent,
      }
    })

    // 소수점 반올림 후 총합이 100이 되도록 보정
    const roundedPercents = percentData.map(
      (d) => Math.round(d.percent * 10) / 10,
    )
    const totalPercent = roundedPercents.reduce((a, b) => a + b, 0)
    const diff = +(100 - totalPercent).toFixed(1)

    // 퍼센트 합이 100%가 안되면 가장 득표 수가 많은 항목에 보정치 추가
    if (diff !== 0) {
      const maxIndex = percentData.reduce(
        (maxIdx, curr, idx, arr) =>
          curr.voteCount > arr[maxIdx].voteCount ? idx : maxIdx,
        0,
      )
      roundedPercents[maxIndex] += diff
    }

    return percentData.map((item, index) => ({
      title: item.optionTitle,
      value: `${item.voteCount.toLocaleString()}표`,
      target: `${roundedPercents[index].toFixed(1)}%`,
      progress: roundedPercents[index],
      className: classNames[index % classNames.length],
    }))
  }

  const generateGenderData = (
    genderResult: GenderResultData[],
    optionList: string[],
  ) => {
    if (!genderResult || genderResult.length === 0) return []

    const maleTotal = genderResult
      .filter((item) => item.gender === 'M')
      .reduce((sum, item) => sum + (item.resultCount || 0), 0)

    const femaleTotal = genderResult
      .filter((item) => item.gender === 'F')
      .reduce((sum, item) => sum + (item.resultCount || 0), 0)

    const totalGenderVotes = maleTotal + femaleTotal

    // 원 퍼센트 계산
    const rawMalePercent =
      totalGenderVotes > 0 ? (maleTotal / totalGenderVotes) * 100 : 0
    const rawFemalePercent =
      totalGenderVotes > 0 ? (femaleTotal / totalGenderVotes) * 100 : 0

    // 반올림 및 100% 보정
    let malePercent = Math.round(rawMalePercent * 10) / 10
    let femalePercent = Math.round(rawFemalePercent * 10) / 10
    const percentSum = malePercent + femalePercent
    const diff = +(100 - percentSum).toFixed(1)

    if (diff !== 0) {
      if (maleTotal >= femaleTotal) {
        malePercent += diff
      } else {
        femalePercent += diff
      }
    }

    // 성별별 최다 득표 옵션
    const maleTopOption = genderResult
      .filter((item) => item.gender === 'M')
      .reduce(
        (max, item) =>
          (item.resultCount || 0) > (max.resultCount || 0) ? item : max,
        { resultCount: 0, optionTitle: '', resultPercent: 0 },
      )

    const femaleTopOption = genderResult
      .filter((item) => item.gender === 'F')
      .reduce(
        (max, item) =>
          (item.resultCount || 0) > (max.resultCount || 0) ? item : max,
        { resultCount: 0, optionTitle: '', resultPercent: 0 },
      )

    return [
      {
        title: '남성 투표수',
        value: `${maleTotal.toLocaleString()}표`,
        target: `${malePercent.toFixed(1)}%`,
        progress: malePercent,
        className: 'male-vote',
      },
      {
        title: '여성 투표수',
        value: `${femaleTotal.toLocaleString()}표`,
        target: `${femalePercent.toFixed(1)}%`,
        progress: femalePercent,
        className: 'female-vote',
      },
      {
        title: '남성 최다 선택',
        value:
          maleTopOption.optionTitle.length > 8
            ? `${maleTopOption.optionTitle.substring(0, 8)}...`
            : maleTopOption.optionTitle,
        target: `${maleTopOption.resultCount}표`,
        progress: maleTopOption.resultPercent || 0,
        className: 'male-vote',
      },
      {
        title: '여성 최다 선택',
        value:
          femaleTopOption.optionTitle.length > 8
            ? `${femaleTopOption.optionTitle.substring(0, 8)}...`
            : femaleTopOption.optionTitle,
        target: `${femaleTopOption.resultCount}표`,
        progress: femaleTopOption.resultPercent || 0,
        className: 'female-vote',
      },
    ]
  }

  // 연령대 결과 데이터 생성
  const generateAgeData = (
    ageResult: AgeResultData[],
    optionList: string[],
  ) => {
    if (!ageResult || ageResult.length === 0) return []

    // 연령대별 총 투표수 계산
    const ageGroups = [...new Set(ageResult.map((item) => item.ageGroup))]
    const ageGroupTotals = ageGroups.map((group) => ({
      group,
      total: ageResult
        .filter((item) => item.ageGroup === group)
        .reduce((sum, item) => sum + (item.ageCount || 0), 0),
    }))

    const totalAgeVotes = ageGroupTotals.reduce(
      (sum, item) => sum + item.total,
      0,
    )
    const mostActiveAgeGroup = ageGroupTotals.reduce(
      (max, item) => (item.total > max.total ? item : max),
      { group: '', total: 0 },
    )

    // 연령대별 최다 선택 옵션
    const ageTopOptions = ageGroups.map((group) => {
      const groupResults = ageResult.filter((item) => item.ageGroup === group)
      return groupResults.reduce(
        (max, item) =>
          (item.ageCount || 0) > (max.ageCount || 0) ? item : max,
        { ageGroup: group, optionTitle: '', ageCount: 0 },
      )
    })

    const overallTopAgeOption = ageTopOptions.reduce(
      (max, item) => ((item.ageCount || 0) > (max.ageCount || 0) ? item : max),
      { ageGroup: '', optionTitle: '', ageCount: 0 },
    )

    // 20대부터 70대까지 순서대로 데이터 생성
    const ageOrder = ['20대', '30대', '40대', '50대', '60대', '70대']
    const ageDetailsData = ageOrder.map((ageGroup) => {
      const ageData = ageGroupTotals.find((item) => item.group === ageGroup)
      const votes = ageData ? ageData.total : 0
      const percentage = totalAgeVotes > 0 ? (votes / totalAgeVotes) * 100 : 0

      return {
        title: ageGroup,
        value: `${votes}표`,
        target: `${Math.round(percentage * 10) / 10}%`,
        percentage: `${Math.round(percentage * 10) / 10}%`,
        progress: percentage,
        className: `age${ageGroup.replace('대', 's')}`, // age-20s, age-30s 등
      }
    })

    // 20대부터 70대까지만 반환
    return ageDetailsData
  }

  const getCurrentData = () => {
    switch (activeTab) {
      case 'result':
        return generateResultData(rawSurveyResult)
      case 'gender':
        return generateGenderData(rawGenderResult, optionList)
      case 'age':
        return generateAgeData(rawAgeResult, optionList)
      default:
        return generateResultData(rawSurveyResult)
    }
  }

  const currentData = getCurrentData()

  const legendItems = surveyResult.map((item, index) => ({
    letter: String.fromCharCode(65 + index),
    title: item.optionTitle,
    color: colors[index % colors.length],
  }))

  return (
    <>
      {!isMobile ? (
        <div className="accordion">
          {surveyList.map((item, index) => (
            <div
              key={index}
              className={`accordion-item ${activeIndex === index ? 'active' : ''}`}
            >
              <div
                className={`accordion-header ${
                  activeIndex === index
                    ? item.surveyActive === 'Y'
                      ? 'accordion-header-yellow'
                      : 'accordion-header-gray'
                    : ''
                }`}
                onClick={() => handleClick(index)}
              >
                <Badge
                  color={`${item.surveyActive === 'Y' ? 'success' : 'secondary'}`}
                >
                  <span style={{ fontSize: '11px', fontWeight: 'bold' }}>
                    {getSurveyStatusLabel(item.surveyActive)}
                  </span>
                </Badge>

                <div className="accordion-title">{item.surveyTitle}</div>

                <div style={{ flexShrink: '0' }}>
                  {`${getRemainingTime(item.surveyEndDate)} | 투표 인원 : ${item.totalVoters}명`}
                </div>
              </div>

              {activeIndex === index && (
                <>
                  <div
                    className={`survey-desc ${item.surveyActive === 'Y' ? 'active' : 'inactive'}`}
                  >
                    {item.surveyDesc}
                  </div>
                  <div className="accordion-content">
                    <div className="poll-result-container">
                      <div
                        style={{ display: 'flex', justifyItems: 'flex-end' }}
                      >
                        {`투표기간 : ${formatDate(item.surveyStartDate)} - ${formatDate(item.surveyEndDate)}`}
                      </div>
                      <div
                        className={`poll-result ${item.surveyActive === 'Y' ? 'active' : 'inactive'}`}
                        onClick={() =>
                          showSurveyResult(
                            item.surveySn,
                            item.totalVoters,
                            item.surveyActive,
                          )
                        }
                      >
                        {`${item.surveyActive === 'Y' ? '투표 현황' : '투표 결과'}`}
                      </div>
                    </div>
                    <div className="poll-options">
                      {item.options.map((option, idx) => {
                        const userVoted = item.userOptionSn !== null // 백엔드에서 내려준 값
                        const comments = commentList[option.optionSn] || [] // 옵션별 댓글 뽑기
                        const selectedUserOpt =
                          option.optionSn === option.userOptionSn
                        const isVotingClosed = item.surveyActive === 'N' // 투표 종료 여부
                        return (
                          <div className="poll-item" key={option.optionSn}>
                            <div
                              className={`poll-option ${
                                selectedUserOpt ? 'selected' : ''
                              }`}
                            >
                              <div className="poll-title">
                                {option.optionTitle}
                              </div>
                              <div className="poll-content">
                                {option.optionDesc}
                              </div>
                              <div
                                className={`poll-button ${selectedUserOpt ? 'selected' : ''}`}
                                style={{
                                  marginBottom: '20px',
                                  cursor: isVotingClosed
                                    ? 'not-allowed'
                                    : 'pointer',
                                }}
                                onClick={() => {
                                  if (isVotingClosed) {
                                    // 투표가 종료된 경우 처리
                                    showAlert({
                                      type: 'error',
                                      title: '투표가 종료된 항목이에요.',
                                    })
                                    return
                                  }

                                  if (selectedUserOpt) {
                                    showAlert({
                                      type: 'error',
                                      title: '이미 투표한 항목이에요.',
                                    })
                                    return
                                  }

                                  if (!isVotingClosed) {
                                    handleModalAction(
                                      'submit',
                                      option.optionSn,
                                      item.surveySn,
                                      userVoted,
                                    )
                                  }
                                }}
                              >
                                {isVotingClosed
                                  ? '투표종료'
                                  : selectedUserOpt
                                    ? '✅ 투표완료'
                                    : userVoted
                                      ? '재투표'
                                      : '투표하기'}
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'right',
                                }}
                              >
                                {option.votePercent != null &&
                                  option.surveyCount != null && (
                                    <>
                                      {`${option.votePercent}% | 총 ${option.surveyCount}표`}
                                    </>
                                  )}
                              </div>
                            </div>
                            <div
                              className="comment-section"
                              key={option.optionSn}
                            >
                              <textarea
                                placeholder={
                                  isVotingClosed
                                    ? '종료된 투표에는 댓글을 작성할 수 없어요.'
                                    : !isAuthenticated
                                      ? '댓글을 남기시려면 로그인이 필요해요.'
                                      : '댓글을 입력하세요.'
                                }
                                rows={3}
                                className="comment-input"
                                maxLength={255}
                                id="commentCn"
                                name="commentCn"
                                value={formData[option.optionSn] || ''}
                                onChange={(e) =>
                                  handleChange(option.optionSn, e.target.value)
                                }
                                onFocus={() => {
                                  if (isVotingClosed) {
                                    showAlert({
                                      type: 'error',
                                      title:
                                        '종료된 투표에는 댓글을 작성할 수 없어요.',
                                    })
                                  }
                                  if (!isAuthenticated || !user) {
                                    showAlert({
                                      type: 'error',
                                      title:
                                        '댓글을 남기시려면 로그인이 필요해요.',
                                    })
                                  }
                                }}
                                disabled={
                                  isVotingClosed || !isAuthenticated || !user
                                }
                              />
                            </div>
                            {!isVotingClosed && isAuthenticated && (
                              <div
                                className="comment-submit"
                                onClick={() => {
                                  insertComment(option.optionSn, item.surveySn)
                                }}
                                style={{
                                  cursor: 'pointer',
                                }}
                              >
                                등록
                              </div>
                            )}
                            <div style={{ marginBottom: '10px' }} />
                            <div className="comment-container">
                              {comments.map((comment) => {
                                return (
                                  <div
                                    key={comment.commentSn}
                                    className="comment-list"
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <div style={{ fontWeight: 'bold' }}>
                                        {comment.nickName}
                                      </div>
                                      <div>
                                        {commonUtils.formatDate(
                                          comment.regDate,
                                        )}
                                      </div>
                                    </div>

                                    <div className="comment-contents">
                                      {comment.adminDelYn === 'Y'
                                        ? '관리자에 의해 삭제된 댓글입니다.'
                                        : comment.withDrawYn === 'Y'
                                          ? withDrawnCumtomer.contents
                                          : comment.commentCn}
                                    </div>

                                    {isAuthenticated &&
                                      user?.cstId === comment.cstId && (
                                        <div
                                          style={{
                                            display: 'flex',
                                            justifyContent: 'right',
                                            color: '#979797',
                                            cursor: 'pointer',
                                          }}
                                          onClick={() =>
                                            deleteComment(
                                              comment.commentSn,
                                              surveySn,
                                            )
                                          }
                                        >
                                          삭제
                                        </div>
                                      )}
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      ) : (
        <>
          {/* {isMobile && (
            <p style={{ fontSize: '12px', color: 'red', marginBottom: '0px' }}>
              투표현황/결과는 PC화면에서 확인 가능해요.
            </p>
          )} */}
          <div className="mobile-survey-container" style={{ marginTop: '0px' }}>
            <main className="mobile-survey-main">
              {surveyList.map((item, index) => (
                <React.Fragment key={item.surveySn || index}>
                  <section
                    className={`${item.surveyActive === 'Y' ? 'mobile-survey-current-poll' : 'mobile-survey-end-poll'}`}
                  >
                    <div
                      className="mobile-survey-poll-header"
                      onClick={() => handleClick(index)}
                    >
                      <span
                        className={`${item.surveyActive === 'Y' ? 'mobile-survey-poll-status' : 'mobile-survey-end-status'}`}
                      >
                        {getSurveyStatusLabel(item.surveyActive)}
                      </span>
                      <span className="mobile-survey-poll-meta">
                        {`${getRemainingTime(item.surveyEndDate)} | 투표 인원 : ${item.totalVoters}명`}
                      </span>
                    </div>

                    {/* 설문 내용 - active 클래스로 show/hide 제어 */}
                    <div
                      className={`mobile-survey-content ${activeIndex === index ? 'active' : ''}`}
                    >
                      <div className="mobile-survey-poll-question">
                        {item.surveyTitle}
                      </div>
                      <div className="mobile-survey-poll-description">
                        {item.surveyDesc}
                      </div>
                      <div className="mobile-survey-poll-period">
                        {`투표기간 : ${formatDate(item.surveyStartDate)} - ${formatDate(item.surveyEndDate)}`}
                      </div>
                    </div>
                  </section>

                  {/* 설문 옵션들 - active 클래스로 show/hide 제어 */}
                  <section
                    className={`mobile-survey-options ${activeIndex === index ? 'active' : ''}`}
                  >
                    {item.options.map((option, optionIndex) => {
                      const userVoted = item.userOptionSn !== null
                      const comments = commentList[option.optionSn] || []
                      const selectedUserOpt =
                        option.optionSn === item.userOptionSn
                      const isVotingClosed = item.surveyActive === 'N'
                      const commentKey = `${index}-${optionIndex}`
                      const isCommentOpen = openComments.includes(commentKey)

                      return (
                        <div
                          key={option.optionSn}
                          className="mobile-survey-option-card"
                        >
                          <div className="mobile-survey-option-header">
                            <div className="mobile-survey-option-title">
                              {option.optionTitle}
                            </div>
                            <div className="mobile-survey-option-votes">
                              {option.votePercent != null &&
                                option.surveyCount != null && (
                                  <>
                                    {`${option.votePercent}% | 총 ${option.surveyCount}표`}
                                  </>
                                )}
                            </div>
                          </div>
                          <div className="mobile-survey-option-description">
                            {option.optionDesc}
                          </div>

                          <div className="mobile-survey-option-actions">
                            <button
                              className={`mobile-survey-option-button ${selectedUserOpt ? 'selected' : ''}`}
                              style={{
                                cursor: isVotingClosed
                                  ? 'not-allowed'
                                  : 'pointer',
                              }}
                              onClick={() => {
                                if (isVotingClosed) {
                                  showAlert({
                                    type: 'error',
                                    title: '투표가 종료된 항목이에요.',
                                  })
                                  return
                                }

                                if (selectedUserOpt) {
                                  showAlert({
                                    type: 'error',
                                    title: '이미 투표한 항목이에요.',
                                  })
                                  return
                                }

                                if (!isVotingClosed) {
                                  handleModalAction(
                                    'submit',
                                    option.optionSn,
                                    item.surveySn,
                                    userVoted,
                                  )
                                }
                              }}
                            >
                              {isVotingClosed
                                ? '투표종료'
                                : selectedUserOpt
                                  ? '✅ 투표완료'
                                  : userVoted
                                    ? '재투표'
                                    : '투표하기'}
                            </button>
                            <button
                              className="mobile-survey-comment-toggle"
                              onClick={() =>
                                handleCommentToggle(index, optionIndex)
                              }
                            >
                              💬 댓글보기
                            </button>
                          </div>

                          {/* 댓글 섹션 - active 클래스로 show/hide 제어 */}
                          <div
                            className={`mobile-survey-option-comment-section ${isCommentOpen ? 'active' : ''}`}
                          >
                            <div className="mobile-survey-comment-actions">
                              <textarea
                                className="mobile-survey-comment-input"
                                placeholder={
                                  isVotingClosed
                                    ? '종료된 투표에는 댓글을 작성할 수 없어요.'
                                    : !isAuthenticated
                                      ? '댓글을 남기시려면 로그인이 필요해요.'
                                      : '댓글을 입력하세요.'
                                }
                                rows={5}
                                maxLength={255}
                                id="commentCn"
                                name="commentCn"
                                value={formData[option.optionSn] || ''}
                                onChange={(e) =>
                                  handleChange(option.optionSn, e.target.value)
                                }
                                onFocus={() => {
                                  if (isVotingClosed) {
                                    showAlert({
                                      type: 'error',
                                      title:
                                        '종료된 투표에는 댓글을 작성할 수 없어요.',
                                    })
                                  }
                                  if (!isAuthenticated || !user) {
                                    showAlert({
                                      type: 'error',
                                      title:
                                        '댓글을 남기시려면 로그인이 필요해요.',
                                    })
                                  }
                                }}
                                disabled={
                                  isVotingClosed || !isAuthenticated || !user
                                }
                              />
                              {!isVotingClosed && isAuthenticated && (
                                <button
                                  className="mobile-survey-comment-submit"
                                  onClick={() => {
                                    insertComment(
                                      option.optionSn,
                                      item.surveySn,
                                    )
                                  }}
                                >
                                  댓글 작성
                                </button>
                              )}
                            </div>
                            {comments.map((comment) => (
                              <div
                                className="mobile-survey-comment-list"
                                key={comment.commentSn}
                              >
                                <div className="mobile-survey-comment-item">
                                  <div className="mobile-survey-comment-card">
                                    <div className="mobile-survey-comment-nickname">
                                      {comment.nickName}
                                    </div>
                                    <div className="mobile-survey-comment-date">
                                      {commonUtils.formatDate(comment.regDate)}
                                    </div>
                                  </div>
                                  <div className="mobile-survey-comment-content">
                                    {comment.adminDelYn === 'Y'
                                      ? '관리자에 의해 삭제된 댓글입니다.'
                                      : comment.withDrawYn === 'Y'
                                        ? withDrawnCumtomer.contents
                                        : comment.commentCn}
                                  </div>
                                  {isAuthenticated &&
                                    user?.cstId === comment.cstId && (
                                      <div
                                        className="mobile-survey-comment-delete"
                                        onClick={() =>
                                          deleteComment(
                                            comment.commentSn,
                                            item.surveySn,
                                          )
                                        }
                                      >
                                        삭제
                                      </div>
                                    )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )
                    })}
                  </section>
                </React.Fragment>
              ))}
            </main>
          </div>
        </>
      )}
      {isAuthenticated && showResults && (
        <>
          <div className="modal-overlay">
            <div className="result-container">
              <div className="result-header">
                <div onClick={closeModal}>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    width={'18px'}
                    height={'18px'}
                  >
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M5 5L19 19M5 19L19 5"
                        stroke="#000000"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </g>
                  </svg>
                </div>
              </div>
              <div className="result-charts-container"></div>
              <div className="result-barchart">
                <div style={{ flexDirection: 'column' }}>
                  <div className="tab-container">
                    {tabs.map((tab) => (
                      <button
                        key={tab.key}
                        className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
                        onClick={() => handleTabClick(tab.key)}
                      >
                        {tab.label}
                      </button>
                    ))}
                  </div>
                  {currentChartData && (
                    <>
                      <ApexBarChart
                        options={currentChartData.options}
                        series={currentChartData.series}
                        height={300}
                        width={510}
                      />
                    </>
                  )}
                </div>
                <div className="dashboard-container">
                  {currentData.map((metric, index) => (
                    <div
                      key={metric.title}
                      className={`metric-card ${metric.className}`}
                    >
                      <div className="metric-header">
                        <div className="metric-title">{metric.title}</div>
                      </div>
                      <div className="metric-value-container">
                        <div className="metric-value">{metric.value}</div>
                        <div className="metric-target">{metric.target}</div>
                      </div>
                      <div className="progress-container">
                        <div
                          className="progress-bar"
                          style={{
                            width: animateProgress
                              ? `${metric.progress}%`
                              : '0%',
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}
